import styles from "../../styles/General/Input.module.css"
import styled from "styled-components";
import { forwardRef, useState } from 'react'
import { MixpanelTracking } from "../../MixPanel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import format from "date-fns/format";

const StyledInput = styled.input`
    &:disabled {
        opacity : 0.6;
    }
    &::before {
        content: attr(placeholder);
        position: absolute;
        color: #999999;
    }

    &:focus::before,
    &:valid::before {
        content: "";
    }

    color-scheme: dark;
`

function Input(props: any, ref : any) {     
    const type = props.type || 'text';
    const placeholder = props.placeholder || ''
    const prefix = props.prefix || ''
    const suffix = props.suffix || ''
    const outerProperties = props.outerProperties || ''
    const autoComplete = props.search || false;
    const background = props.background || 'white'
    const color = props.color || 'black'
    const labelColor = props.labelColor || 'white'
    const labelProperties = props.labelProperties || ''
    const touched : boolean = props.touched || false
    const error : string = props.error || null
    const searchResults = props.searchResults || []
    const value = props.value || ''
    const maxLength = props.maxLength || ''
    const min = props.min || ''
    const disabled = props.disabled || false;

    const [isFocused, setIsFocused] = useState(false);

    // FUNCTION
    const handleOnFocus = () => {
        if(props.onFocus)
            props.onFocus();

        const mixPanelData = {
            inputName : props.name ? props.name : '',
            inputValue : value
        }
        MixpanelTracking.getInstance().trackInput(mixPanelData);
    }

    const handleOnChange = (event : any) => {
        if(props.onChange)
            props.onChange(event);
        
        setIsFocused(() => true);
        const mixPanelData = {
            inputName : props.name ? props.name : '',
            inputValue : type !== 'password' ? event.target.value : '**********'
        }

        if(props.name !== 'ProductSearch')
            MixpanelTracking.getInstance().trackInput(mixPanelData, true)
    }

    const handleDateChange = (e : any) => {
        props.handleDateChange(e);
        setIsFocused(!isFocused);
    };

    const handleKeyDown = (event : any) => {
        if(event.keyCode === 13) {
            if(props.onPressingEnter)
                props.onPressingEnter(event);
        }
    }
  
    return (
        <div className="flex-col">
            {
                props.label && 
                <label className={`inline-block mb-1 ${labelProperties}`} style={{ color : labelColor }}> {props.label} </label>
            }
            <div 
                onClick={() => ref && ref.current.focus()} 
                className={`flex bg-white justify-center items-center cursor-text ${outerProperties}`} 
                style={{ background : background, ...props.additionalStyles }}
            >
                {
                    prefix && 
                    <div className={styles.prefix}>
                        {prefix}
                    </div>
                }

                <StyledInput
                    ref = {ref}
                    className={`${styles.input} focus:outline-0 placeholder:font-[300] ${props.properties}`}
                    type={type}
                    placeholder={placeholder}
                    style={{ background : background, color : color }}
                    onChange={handleOnChange}
                    onInput={props.onInput}
                    name = {props.name}
                    onBlur = {props.onBlur}
                    value={value}
                    maxLength={maxLength}
                    min={min}
                    disabled = {disabled}
                    onFocus = {handleOnFocus}
                    onKeyDown={handleKeyDown}
                    autoComplete="off"
                />

                <div className="suffix">
                    {suffix}
                </div>
            </div>

            {error && touched &&
                <small className="text-error"> { error } </small>
            }

            <div className="">
                {   autoComplete && searchResults.length > 0 &&
                    <div className={`absolute z-[999] ${styles.suggestions} rounded`} style={{ boxShadow : '0px 3px 20px #0000002C' }}>
                        { searchResults }
                    </div>
                }
            </div>
        </div>
    )
}

export default forwardRef(Input)